import styled from 'styled-components'

const Content = styled.div`
  padding: ${({ theme }) => theme.spacing[32]};
`

export default Content
